module.exports = __webpack_public_path__ + "static/media/library.ad316337.png";